import React from "react";
import { Box } from "@mui/material";
import { CustomLoading, colors } from "@ippon/shared-components";
import CustomBrandLogo from "../logo/BrandLogo";

export interface CustomAuthLoadingProps {
  /** ロゴの下に出すサービス名（例: 物件管理）。ログイン画面の CustomBrandLogo と同じ表示 */
  label?: string;
}

/**
 * 認証の確認中（トークンの取り直し中など）に、画面を出す前に表示するローディング。
 * 黒い膜（CustomLoading の全画面モード）は使わず、白い画面の中央に
 * ログイン画面と同じロゴとスピナーを出す。各サービスで label だけ変えて使う。
 */
const CustomAuthLoading: React.FC<CustomAuthLoadingProps> = ({ label }) => (
  <Box
    role="status"
    aria-label="読み込み中"
    sx={{
      position: "fixed",
      inset: 0,
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      gap: 1,
      backgroundColor: colors.background.paper,
    }}
  >
    <CustomBrandLogo label={label} />
    <CustomLoading loading={true} fullScreen={false} size="medium" />
  </Box>
);

export default CustomAuthLoading;
